<template>
  <section class="content">
    <loader v-show="loading" />
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      tableTitle="GST-VAT"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"     
    />
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'QuoteTaxSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    computed: {
      fields () {
        return [
          { header: 'Location', prop: ({location}) => location ? (location.name + (location.country ? (', ' + location.country.code) : '')) : '' },
          { header: 'Rate', prop: 'rate' },
          { header: 'Service', prop: 'service' }
        ]
      }
    },
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'quote-tax',
        editEntityScreen: 'Admin - Edit/View Quote Tax',
        shouldSearchForExactMatch: true,
        orderBy: 'location ASCENDING'
      }
    }
  }
</script>

<style scoped>
  .input-group input {
    border-radius: 30px 0 0 30px;
  }
  .input-group .input-group-addon {
    border-radius: 0 30px 30px 0;
  }
  .center-children-sm > * {
    border-radius: 0;
  }
  @media (max-width: 768px) {
    .center-children-sm > * {
      width:33%;
    }
  }
</style>



// WEBPACK FOOTER //
// QuoteTaxSearchResults.vue?d5f0a5bc